import { Employee } from "../employee.model";
import { ResultBase } from "../general/result.model";

export class ErrorDialogData extends ResultBase {
    title: string;
    employeeErrorList: {[key: string]: Employee[]};
    employeeWarningList: {[key: string]: Employee[]};
    importFieldErrors?: {[key: string]: number[]};
    defaultErrorKey: string;
} 